import type React from 'react';
import { useCallback } from 'react';

const NAVIGATION_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Backspace', 'Delete', 'End', 'Enter', 'Escape', 'Home', 'Tab'];
const OPERATION_KEYS = ['a', 'c', 'v', 'x', 'z'];

export const useInputRestriction = (pattern: RegExp) => {
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (NAVIGATION_KEYS.includes(event.key) || ((event.ctrlKey || event.metaKey) && OPERATION_KEYS.includes(event.key.toLowerCase()))) return;

      if (!pattern.test(event.key)) event.preventDefault();
    },
    [pattern],
  );

  const handlePaste = useCallback(
    (event: React.ClipboardEvent<HTMLInputElement>, onChange: (value: unknown) => void) => {
      event.preventDefault();

      const input = event.currentTarget;
      const { selectionStart, selectionEnd, value } = input;
      const text = event.clipboardData.getData('text');
      const cleanedText = text
        .split('')
        .filter((char) => pattern.test(char))
        .join('');
      const newValue = value.slice(0, selectionStart ?? 0) + cleanedText + value.slice(selectionEnd ?? 0);

      onChange(newValue);
    },
    [pattern],
  );

  return [handleKeyDown, handlePaste] as const;
};
